//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// loader-clock-with-message imports
import { styles } from "./LoaderClockWithMessage.styles";
// other internals
import { LoaderClock } from "@components/loader-clock";
import spacing from "@styles/spacing.styles";
// material-ui
import { WithStyles } from "@material-ui/core/styles/withStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";

interface IProps extends WithStyles<typeof styles> {
  message?: string;
}

interface IState {}

//////////////////
// COMPONENT
//////////////////
class LoaderClockWithMessageCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    return (
      <div className={this.props.classes.root}>
        <div className={this.props.classes.loader}>
          <LoaderClock />
        </div>
        <Typography variant="h6" style={{ fontWeight: "normal", paddingTop: spacing.lg24 }}>
          {this.props.message}
        </Typography>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const LoaderClockWithMessage = withStyles(styles)(LoaderClockWithMessageCmpt);
